import React from "react";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Spinner,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const PointForm = ({ point, isCreating, onSubmit, onCancel, isSaving }: any) => {
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      code: point?.code || "",
      currentInvoiceSeq: point?.currentInvoiceSeq || 1,
      currentRetentionSeq: point?.currentRetentionSeq || 1,
      currentWaybillSeq: point?.currentWaybillSeq || 1,
    },
    validationSchema: Yup.object({
      code: Yup.string().required("El código es requerido"),
      currentInvoiceSeq: Yup.number().required("Requerido").min(1),
      currentRetentionSeq: Yup.number().required("Requerido").min(1),
      currentWaybillSeq: Yup.number().required("Requerido").min(1),
    }),
    onSubmit: (values) => {
      onSubmit({
        ...values,
        currentInvoiceSeq: Number(values.currentInvoiceSeq),
        currentRetentionSeq: Number(values.currentRetentionSeq),
        currentWaybillSeq: Number(values.currentWaybillSeq),
      });
    },
  });

  return (
    <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }} className="p-3 border rounded bg-light mb-3">
      <div className="d-flex align-items-center mb-3">
          <h6 className="flex-grow-1 mb-0 fw-bold">{isCreating ? "Nuevo Punto de Emisión" : "Editar Punto de Emisión"}</h6>
      </div>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label className="small">Código (Ej: 001)</Label>
            <Input bsSize="sm" name="code" value={validation.values.code} onChange={validation.handleChange} onBlur={validation.handleBlur} invalid={!!validation.touched.code && !!validation.errors.code} />
            {validation.touched.code && validation.errors.code ? <FormFeedback>{validation.errors.code as string}</FormFeedback> : null}
          </FormGroup>
        </Col>
        <Col md={4}>
            <FormGroup>
                <Label className="small">Sec. Factura</Label>
                <Input bsSize="sm" type="number" name="currentInvoiceSeq" value={validation.values.currentInvoiceSeq} onChange={validation.handleChange} onBlur={validation.handleBlur} invalid={!!validation.touched.currentInvoiceSeq && !!validation.errors.currentInvoiceSeq} />
            </FormGroup>
        </Col>
        <Col md={4}>
            <FormGroup>
                <Label className="small">Sec. Retención</Label>
                <Input bsSize="sm" type="number" name="currentRetentionSeq" value={validation.values.currentRetentionSeq} onChange={validation.handleChange} onBlur={validation.handleBlur} invalid={!!validation.touched.currentRetentionSeq && !!validation.errors.currentRetentionSeq} />
            </FormGroup>
        </Col>
        <Col md={4}>
            <FormGroup>
                <Label className="small">Sec. Guía</Label>
                <Input bsSize="sm" type="number" name="currentWaybillSeq" value={validation.values.currentWaybillSeq} onChange={validation.handleChange} onBlur={validation.handleBlur} invalid={!!validation.touched.currentWaybillSeq && !!validation.errors.currentWaybillSeq} />
            </FormGroup>
        </Col>
      </Row>
      <div className="d-flex justify-content-end gap-2 mt-2">
        <Button color="light" onClick={onCancel} size="sm" disabled={isSaving}>Cancelar</Button>
        <Button
          color="primary"
          size="sm"
          className="waves-effect waves-light"
          type="submit"
          disabled={isSaving}
        >
          {isSaving ? (
            <>
              <Spinner size="sm" className="me-2" />
              Guardando...
            </>
          ) : (
            <>
              <i className="ri-save-line label-icon align-middle fs-16 me-2"></i>
              Guardar
            </>
          )}
        </Button>
      </div>
    </Form>
  );
};

export default PointForm;
